export default "__VITE_ASSET__gGTxfDxJ__"